import React from 'react';
import { makeStyles } from '@material-ui/core';
import { makeTransparent } from '@axes4/react-common/src/util/colors';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    cardPadding:{
        padding: 16,
    },
    active: {
        background: makeTransparent(theme.palette.primary.main, 0.08),
    },
}));

export interface EnhancedTableToolbarProps<T> {
    allSelected: boolean;
    selectedItems: T[];
    totalItemCount: number;
    getActions?(selectedItems: T[], disabled: boolean): React.ReactNode;
    isCardContent?: boolean;
    getSelectionStatusLabel?(selectedItems: number, totalItems: number): React.ReactNode;
    disabled?: boolean;
}

const EnhancedTableToolbar = <T,>(props: EnhancedTableToolbarProps<T>): JSX.Element => {
    const classes = useStyles();
    const selectionCount = props.selectedItems.length;

    const selectionStatus = props.getSelectionStatusLabel
        ? props.getSelectionStatusLabel(selectionCount, props.totalItemCount)
        : (<>{props.selectedItems.length} selected</>);

    return (
        <div className={clsx(classes.root, props.isCardContent && classes.cardPadding, selectionCount > 0 && classes.active)}>
            <div role="region" aria-live="polite">{selectionCount > 0 && selectionStatus}</div>
            {props.getActions && (
                <div>
                    {props.getActions(props.selectedItems, props.disabled === true)}
                </div>
            )}
        </div>
    );
};

export { EnhancedTableToolbar };
